import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ehm-info',
  templateUrl: './ehm-info.component.html',
  styleUrls: ['./ehm-info.component.css']
})
export class EhmInfoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
